export const buildProvenance = { "commitHash": "5aed92ab96ff5ebb16c59e0bfd936680319f7783", "branchName": "refs/heads/release/2024.1", "buildDate": "2024-04-23T10:34:58.821Z", "version": "2024.1.12587" };
